import { ISlotDTO, slotIntegrationType } from '../types/interfaces/Slots/GameCatalog'

export const getAdditionalIntegrationGameId = (provider: slotIntegrationType, slot: ISlotDTO) => {
  switch (provider) {
    case '028142ca':
      return slot.slug.split(':')[0].split('/').join(':')
    default:
      return slot.game_id
  }
}
